import { axios } from '../axios';

export default async function getDriverOrders(driverId, params = {}) {
  return axios.get(`/drivers/${driverId}/orders`, { params });
}
